import React, { ReactNode } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom';
import compteApi from '../network/api/compteApi';
import rattachementDemandApi from '../network/api/rattachementDemandApi';
import sessionApi from '../network/api/sessionApi';
import { UserDTO } from '../network/api/types/compte/UserDTO';
import { RattachementDemandEntite } from '../network/api/types/RattachementDemand';
import { COLLABORATORS_MANAGEMENT, HOME_PAGE_ROUTE, RATTACHEMENT_DEMANDE } from '../routes';
import { getToken, parseUrl, setToken } from '../services/userService';
import Footer from './layout/Footer';
import Header from './layout/Header';
import AccountHome from './pages/AccountHome';
import CollaboratorsManagement from './pages/collaboratorsManagement/CollaboratorsManagement';
import RattachementDemandes from './pages/rattachementDemande/RattachementDemandes';

type Props = RouteComponentProps;

type State = {
  rattachementDemandEntiteList: RattachementDemandEntite,
  user: UserDTO,
};

class Router extends React.Component<Props, State> {
  state: State = {
    rattachementDemandEntiteList: null,
    user: null,
  };

  authenticate = () => {
    const { login } = parseUrl(this.props.location.search);
    if (login) {
      setToken(login);
    }
    if (!getToken()) {
      sessionApi.fetchUrl().then((url) => window.location.replace(url.connectionLink));
      return;
    }
    this.reloadList();
    compteApi.fetchMyUserDetails()
      .then((user) => this.setState({ user }));
  };

  componentDidMount(): void {
    this.authenticate();
  }

  shouldComponentUpdate(nextProps: Readonly<Props>): boolean {
    if (this.props.location.search !== nextProps.location.search) {
      this.authenticate();
    }
    return true;
  }

  reloadList = (): void => {
    rattachementDemandApi.getRattachementDemand()
      .then((rattachementDemandEntiteList) => {
        this.setState({ rattachementDemandEntiteList });
      });
  };

  fetchEmergencyInfos = (): void => {
    compteApi.fetchMyUserDetails()
      .then((user) => this.setState({ user }));
  };

  render(): ReactNode {
    if (!getToken()) {
      return false;
    }
    return (
      <div className="my-account">
        <Header
          rattachementDemandEntiteList={this.state.rattachementDemandEntiteList}
          isUserManager={this.state.user?.entities?.some((entity) =>
            entity.rattachement.naturalManager || entity.rattachement.manager)}
        />
        <div>
          <Switch>
            <Route path={HOME_PAGE_ROUTE}>
              <AccountHome
                myUserDetails={this.state.user}
                fetchEmergencyInfos={this.fetchEmergencyInfos}
              />
            </Route>
            <Route path={COLLABORATORS_MANAGEMENT} component={CollaboratorsManagement} />
            <Route path={RATTACHEMENT_DEMANDE}>
              <RattachementDemandes
                onUpdateList={this.reloadList}
                rattachementDemands={this.state.rattachementDemandEntiteList}
              />
            </Route>
            <Route path="*" render={() => <Redirect to={HOME_PAGE_ROUTE} />} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Router);
